import getApiClient from '@/plugins/api'

export default {
  name: 'PagarmeKycLinkGenerator',
  props: {
    agency: Object,
  },
  data: function () {
    return {
      pagarmeKycLink: {
        message: null,
        url: null,
        base64_qrcode: null,
        expires_at: null,
        code: null,
      },
    }
  },
  methods: {
    generateKycLink() {
      const id = this.agency.pagarmeId,
        self = this,
        api = getApiClient(self.$store)

      self.$store.commit('startLoading')

      api.get(`/pagarme_recipients/${id}/kyc_link`)
        .then(response => {
          self.pagarmeKycLink = response.data
        })
        .catch(err => {
          self.pagarmeKycLink = err.response.data
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        alert('Link copiado para a área de transferência!')
      }).catch(err => {
        console.error('Erro ao copiar: ', err)
      })
    },

    getQrCodeSvg() {
      if (this.pagarmeKycLink.base64_qrcode) {
        return atob(this.pagarmeKycLink.base64_qrcode)
      }
    }
  },
}
